<template>
  <div class="taskDispatch">
    <el-form :inline="true">
      <el-row>
        <el-form-item label="项目名称：">
          <el-input v-model="query.projectName"></el-input>
        </el-form-item>
        <el-form-item label="合同名称：">
          <el-input v-model="query.contractName"></el-input>
        </el-form-item>
        <el-button type="primary" @click="getProjectList">查询</el-button>
      </el-row>
    </el-form>
    <el-table :data="list" border style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        width="55px"
        align="center"
      ></el-table-column>
      <el-table-column prop="projectName" label="项目名称" min-width="30%">
      </el-table-column>
      <el-table-column
        prop="managerName"
        label="项目经理"
        min-width="10%"
      ></el-table-column>
      <el-table-column prop="name" label="项目日期" width="200px">
        <template slot-scope="scope">
          <span
            >{{ scope.row.startDate | filterDate }} ~
            {{ scope.row.endDate | filterDate }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="timeSchedule"
        label="时间进度"
        min-width="10%"
      ></el-table-column>
      <el-table-column prop="total" label="总工程量金额" min-width="10%">
        <template slot-scope="scope">
          <span>￥{{ scope.row.total }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="offProjectSchedule"
        label="已完成工程量进度"
        min-width="10%"
      ></el-table-column>
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-button @click="goToDetail(scope.row)" type="text"
            >任务分配</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import TaskDispatchApi from '@/api/taskDispatch';
import CommonUtil from '@/utils/commonUtil';
export default {
  name: 'TaskDispatch',
  data() {
    return {
      list: [],
      total: 0,
      query: {
        current: 0,
        size: 10,
        projectName: '',
        contractName: '',
      },
    };
  },
  mounted() {
    this.getProjectList();
  },
  filters: {
    filterDate(val) {
      if (val) {
        let date = new Date(val);
        return CommonUtil.parseTime(date, 'yyyy-MM-dd');
      }
      return '';
    },
  },
  methods: {
    getProjectList() {
      TaskDispatchApi.getProjectListPage(this.query).then((res) => {
        if (res.data.code === 200) {
          // console.log('-->>', res);
          this.list = res.data.data.records;
          this.total = res.data.data.total;
        }
      });
    },
    goToDetail(row) {
      this.$router.push('/projectDetail?id=' + row.projectId);
    },
    handleCurrentChange(val) {
      this.query.current = val;
      this.getProjectList();
    },
    handleSizeChange(val) {
      this.query.size = val;
      this.query.current = 0;
      this.getProjectList();
    },
  },
};
</script>

<style lang="scss" scoped>
.taskDispatch {
  padding: 20px;
}
</style>
